import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/social-linkedin.svg';

export const IconSocialLinkedin: IconComponent = props => <Icon {...props} src={src} />;
